const preLoadCheckout = (state: any = { done: false }, action: any) => {
  switch (action.type) {
    case 'preLoadCheckout':
      return { done: true };
    default:
      return state;
  }
};

export default preLoadCheckout;
